<template>
  <!-- Banner Section -->
  <section class="hero-section-six">

    <div class="hero-section-overlay-img d-none d-lg-block">
		<div class="gradient-img">
			<img src="@/assets/img/bg/index-g-overlay-gradient.png" alt="img" class="img-fluid">
		</div>
		<div class="white-circle">
			<img src="@/assets/img/bg/index-6-left-circle.png" alt="img" class="img-fluid">
		</div>
		<div class="main-bg">
			<img src="@/assets/img/bg/index-6-bg.png" alt="img" class="img-fluid">
		</div>
		<div class="top-circle">
			<img src="@/assets/img/bg/index-6-top-circle.png" alt="img" class="img-fluid">
		</div>
		<div class="right-img">
			<img src="@/assets/img/bg/index-6-right-img.png" alt="img" class="img-fluid">
		</div>
		<div class="oval-img">
			<img src="@/assets/img/bg/index-6-oval-img.png" alt="img" class="img-fluid">
		</div>
	</div>

	<layout-header></layout-header>

    <div class="container">
      <div class="home-banner home-banner-six">
        <div class="row w-100 justify-content-center ">
          <div class="col-lg-6 col-12">
            <div class="home-banner-main d-none  d-lg-block">
              <img src="@/assets/img/services/service-82.png" alt="Image" class="img-fluid">
              
            </div>

          </div>
          <div class="col-lg-6 col-12">
            <div class="home-banner-six-bottom">
              <div class="home-banner-six-detergent">
                <span class="rounded-circle"><img src="@/assets/img/icons/window-cleaner.svg" alt="icon"></span>
                <p class="fs-16">Affordable & Reliable </p>
              </div>
              <h1 class="mb-2 display-5">Professional Cleaning Service <span class="text-primary">You Can Trust</span></h1>
              <p>Our professional cleaning service comes up with a complete solution that makes your
                space sparkle!</p>
              <div class="search-box-two search-box-six">
                <form @submit.prevent="submitForm">
                  <div class="search-input-new line-six">
                    <div class="form-group mb-0">
                      <vue-select :options="Service" placeholder="Service Type" />
                    </div>
                  </div>
                  <div class="search-input-new line-two-six">
                    <div class="form-group mb-0">
                      <input type="text" class="form-control" placeholder="Location">
                    </div>
                  </div>
                  <div class="search-btn">
                    <router-link to="/booking/booking-details" class="btn search_service" type="submit" >Book Now</router-link>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- /Banner Section -->

  <!-- Choose Us -->
  <section class="reason-choose-us">
			<div class="container">
				<div class="section-heading section-heading-six">
					<div class="row">
						<div class="col-md-12 col-12 aos" data-aos="fade-up">
							<div class="reason-six">
								<img src="@/assets/img/icons/cleaner-svgrepo-com.svg" alt="image" class="rounded-circle">
								<p>WHY TRUELY SELL?</p>
							</div>
							<h2>Reasons to <span>Choose Us</span></h2>
						</div>
					</div>
				</div>
				<div class="row">
					<div class="col-md-12">
						<div class="total-client-all">
							<ul class="total-client-half">
								<li class="total-client-mini">
									<div class="total-experts-main">
										<h3>540</h3>
										<p>Total<span>Experts</span></p>
									</div>
								</li>
								<li class="total-client-mini">
									<div class="total-experts-main">
										<h3>215</h3>
										<p>Total<span>Clients</span></p>
									</div>
								</li>
								<li>
									<ul class="total-client-avatar">
										<li>
											<a href="javascript:void(0);">
												<img src="@/assets/img/profiles/avatar-06.jpg" alt="User">
											</a>
										</li>
										<li>
											<a href="javascript:void(0);">
												<img src="@/assets/img/profiles/avatar-07.jpg" alt="image">
											</a>
										</li>
										<li>
											<a href="javascript:void(0);">
												<img src="@/assets/img/profiles/avatar-08.jpg" alt="image">
											</a>
										</li>
										<li>
											<a href="javascript:void(0);">
												<img src="@/assets/img/profiles/avatar-09.jpg" alt="User">
											</a>
										</li>
										<li class="more-set">
											<a href="javascript:void(0);">
												<i class="feather-plus"></i>
											</a>
										</li>
									</ul>
								</li>
							</ul>
							<div>
								<p class="total-client-content">Informed decisions and contributes to the overall quality of the marketplace. It also provides valuable insights to the provider for future improvements.
								</p>
							</div>
						</div>
					</div>
				</div>
				<div class="row justify-content-center">
					<div class="col-lg-3 col-sm-4 col-12 ">
						<div class="professional-cleaning-main ">
							<img src="@/assets/img/icons/quality-svgrepo-com.svg" alt="image" class="rounded-circle">
							<h5 class="text-truncate">High Quality Cleaning</h5>
						</div>
					</div>
					<div class="col-lg-3 col-sm-4 col-12">
						<div class="professional-cleaning-main">
							<img src="@/assets/img/icons/cdn-globe-locations-svgrepo-com.svg" alt="image" class="rounded-circle">
							<h5>Global Locations</h5>
						</div>
					</div>
					<div class="col-lg-3 col-sm-4 col-12">
						<div class="professional-cleaning-main">
							<img src="@/assets/img/icons/support.svg" alt="image" class="rounded-circle">
							<h5>Anytime Support</h5>
						</div>
					</div>
					<div class="col-lg-3 col-sm-4 col-12">
						<div class="professional-cleaning-main">
							<img src="@/assets/img/icons/money-cash-svgrepo-com.svg" alt="image" class="rounded-circle">
							<h5>Spend Efficiently</h5>
						</div>
					</div>
				</div>
			</div>
		</section>
  <!-- /Choose Us -->
</template>

<script>
import { ref } from "vue";
const currentDate = ref(new Date());
export default {
  data() {
    return {
      Service: ["Service Type", "Tornoto", "Texas"],
      startdate: currentDate,
      dateFormat: "dd-MM-yyyy",
    };
  },
  methods: {
    submitForm() {
      this.$router.push("/service/search");
    },
  },
};
</script>
